const LOGIN_PATH = '/login';
const LOGOUT_PATH = '/logout';
const RESET_PASSWORD_PATH = `${LOGIN_PATH}/reset-password`;
const CHANGE_PASSWORD_PATH = '/change-password';
const REMOTE_COLLECTION_PATH = '/';

export {
  LOGIN_PATH,
  LOGOUT_PATH,
  RESET_PASSWORD_PATH,
  CHANGE_PASSWORD_PATH,
  REMOTE_COLLECTION_PATH,
};
